<template>
  <Dialog
    class="fixed inset-0 z-50 py-6 overflow-auto bg-white sm:bg-transparent sm:p-6"
    @close="closeModal"
    @click="closeModal"
  >
    <div
      class="max-w-full sm:max-w-4xl px-6 mx-auto bg-white sm:px-16 md:px-24 sm:py-10 sm:rounded-lg sm:shadow z-20 relative"
    >
      <div class="absolute top-4 right-4">
        <button data-testid="close-modal-button"
          class="h-8 w-8 flex items-center justify-center"
          @click="closeModal"
        >
          <span class="sr-only">Close</span>
          <CloseIcon />
        </button>
      </div>
      <DialogPanel>
        <DialogTitle
          class="flex justify-center mt-6 text-lg leading-tight text-center sm:text-2xl md:text-3xl my-6"
        >
          Confirm Owner
        </DialogTitle>
        <DialogDescription>
          <p class="text-center mt-4 mb-2 text-sm sm:text-base">
            {{ content }}
          </p>
        </DialogDescription>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mx-auto">
          <div style="font-weight: bold;">Existing Owner</div>
          <div style="font-weight: bold;">New Owner</div>
          <div>{{ currentOwner }}</div>
          <div>{{ newOwner }}</div>
          <div>
            <BaseButton data-testid="keep-existing-owner-button" @click="onSaveOrUpdateOwner(CONFIRM_OWNER_MODAL_ACTIONS.save)" class="w-full">
              Keep existing owner & save
            </BaseButton>
          </div>
          <div class="text-center">
            <BaseButton data-testid="save-update-owner-button" @click="onSaveOrUpdateOwner(CONFIRM_OWNER_MODAL_ACTIONS.update)" class="w-full">
              Update owner & save
            </BaseButton>
          </div>
        </div>
        <div class="flex justify-center mt-6">
          <BaseButton
            data-testid="continue-edit-button"
            @click="onSaveOrUpdateOwner(CONFIRM_OWNER_MODAL_ACTIONS.cancel)"
            class="w-full sm:w-auto"
            outlined>
            Continue Editing
          </BaseButton>
        </div>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogDescription,
} from "@headlessui/vue";

import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
import BaseButton from "@/components/shared/Button/BaseButton.vue";
import { CONFIRM_OWNER_MODAL_EVENTS, CONFIRM_OWNER_MODAL_ACTIONS } from "./confirmOwnerModalActions";

const props = defineProps({
  programOrSession: String,
  currentOwner: String,
  newOwner: String,
});

const emit = defineEmits([
  CONFIRM_OWNER_MODAL_EVENTS.onCancel,
  CONFIRM_OWNER_MODAL_EVENTS.onSaveOrUpdateOwner,
]);

function onSaveOrUpdateOwner(action) {
  emit(CONFIRM_OWNER_MODAL_EVENTS.onSaveOrUpdateOwner, action);
}

function closeModal() {
  emit(CONFIRM_OWNER_MODAL_EVENTS.onCancel);
}

const content = computed(() => {
  return `You may have changed the owner of the ${props.programOrSession} while editing. Please review the existing owner and the new owner below before confirming the decision.`;
});
</script>

<style scoped>
/* Optional additional styles */
</style>
